import React, { Fragment } from 'react';
import styles from './index.less';
import {
    Item, SearchResult, MetaOfTemplate, templateTagClassNames, PaymentRequirementType, PriceDetail,
} from '@src/slide/application/service/change-template-service/index.interface';
import i18n from 'i18next';
import classnames from 'classnames';
import Tooltip from '@tencent/dui/esm/components/Tooltip';
import Loading from '@tencent/dui/esm/components/Loading';

interface ITemplateDetailListProps {
    detailList: SearchResult[];
    selectedTopicId: string;
    searchKey: string;
    selectedTemplateId?: string;
    isLoading: boolean;
    onClick(templateId: string, vipType: PaymentRequirementType);
    onMoreClick(topicId: string);
    onBack();
}

export default class TemplateDetailList extends React.Component<ITemplateDetailListProps, any> {
    public constructor(props: ITemplateDetailListProps) {
        super(props);
    }

    public render() {
        const { detailList, selectedTopicId, searchKey, isLoading, selectedTemplateId } = this.props;
        let showDetailList: Partial<SearchResult>[] = detailList;
        let showLength = 3;
        if (selectedTopicId) {
            const detail = detailList.find(detail => detail.topic.id === selectedTopicId);
            if (detail) {
                showDetailList = [detail];
                showLength = 9999;
            }
        } else if (searchKey) {
            const filterItems: Item[] = [];
            const prices: PriceDetail[] = [];
            detailList.forEach((detail) => {
                detail.items.forEach((item) => {
                    if (item.name.includes(searchKey)) {
                        filterItems.push(item);
                    }
                    detail.prices && prices.push(...detail.prices);
                });
            });

            showDetailList = [{
                topic: {
                    name: i18n.t('搜索结果'),
                    id: '',
                },
                items: filterItems,
                prices,
            }];
            showLength = 9999;
        }

        const showTopicList = selectedTopicId || searchKey;

        return <div className={styles['template-detail-list-container']}>
            {
                showDetailList.map(detail => <div
                    key={detail.topic?.id}
                    className={styles['template-detail-list-item-container']}
                    style={{
                        marginBottom: showTopicList && 0,
                    }}
                >
                    {
                        !showTopicList ? this.getAllDetailTitle(detail) : this.getBreadcrumb(detail)
                    }
                    <div
                        className={styles['template-detail-list-item-card-container']}
                    >
                        {
                            detail.items?.slice(0, showLength).map((item, index) => <Fragment key={item.id}>
                                <div
                                    className={styles['card-container']}
                                    style={{
                                        marginRight: (index + 1) % 3 === 0 ? 0 : 15,
                                        marginBottom: showTopicList ? 16 : 0,
                                    }}
                                >
                                    <div className={styles['card-cover']}
                                    >
                                        <div
                                            className={styles['cover-img']}
                                            style={{
                                                background: `url(${this.getCoverSrc(this.getValidMeta(item.metaOfEachType))})`,
                                                backgroundSize: 'cover',
                                            }}
                                        />
                                    </div>
                                    <div className={styles['card-title']}>
                                        <div className={styles['card-title-icon']} />
                                        <div className={styles['card-title-text']}>
                                            {
                                                item.name
                                            }
                                        </div>
                                        <div className={classnames({
                                            [styles['card-vip-icon']]: true,
                                            [styles[this.getVipType(detail, item.id)]]: true,
                                        })} />
                                    </div>
                                    {
                                        item.id !== selectedTemplateId && <div
                                            className={classnames({
                                                [styles['card-mask']]: true,
                                            })}>
                                            <Tooltip
                                                title={i18n.t('预览')}
                                                placement={'bottom'}
                                            >
                                                <div
                                                    onClick={() => {
                                                        if (this.props.isLoading) {
                                                            return;
                                                        }

                                                        this.props.onClick(
                                                            item.id,
                                                            this.getIsSuperVipTemplate(detail, item.id),
                                                        );
                                                    }}
                                                    className={styles['card-preview-button']}>
                                                    <div className={styles['card-preview-button-icon']} />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    }
                                    {
                                        item.id === selectedTemplateId && <div
                                            className={classnames({
                                                [styles['card-load']]: true,
                                            })}>
                                            {
                                                this.props.isLoading ? <div
                                                    className={styles['card-loading']}>
                                                    <div className={styles['card-loading-icon']}>
                                                        <Loading
                                                            spinType={'primary'}
                                                            style={{
                                                                height: 24,
                                                                width: 24,
                                                            }}
                                                        />
                                                    </div>
                                                    <div className={styles['card-loading-text']}>
                                                        {
                                                            i18n.t('生成预览')
                                                        }
                                                    </div>
                                                </div> : <div
                                                    className={styles['card-loading']}>
                                                    <div className={styles['card-loaded-icon']} />
                                                    <div className={styles['card-loading-text']}>
                                                        {
                                                            i18n.t('预览完成')
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            </Fragment>)
                        }
                    </div>
                </div>)
            }
        </div>;
    }

    private getIsSuperVipTemplate = (detail: Partial<SearchResult>, templateId: string) => {
        const templatePrice = detail.prices?.find(price => price.itemId === templateId);

        return templatePrice?.requirements.type || PaymentRequirementType.Free;
    };

    private getVipType = (detail: Partial<SearchResult>, templateId: string) => {
        const templatePrice = detail.prices?.find(price => price.itemId === templateId);

        return templateTagClassNames[templatePrice?.requirements?.type || ''];
    };

    private getBreadcrumb = (detail: Partial<SearchResult>) => <div
        className={classnames({
            [styles['template-detail-list-item-title-breadcrumb']]: true,
        })}
    >
        <div
            onClick={() => {
                this.props.onBack();
            }}
            className={styles['bread-crumb-back']}>
            {
                i18n.t('主题模板')
            }
        </div>
        <div className={styles['bread-crumb-back-arrow']} />
        <div
            className={styles['title-text']}
        >
            { detail.topic?.name }
        </div>
    </div>;

    private getAllDetailTitle = (detail: Partial<SearchResult>) => <div
        className={styles['template-detail-list-item-title']}
    >
        <div
            className={styles['title-text']}
        >
            { detail.topic?.name }
        </div>
        <div
            onClick={() => {
                this.props.onMoreClick(detail.topic?.id || '');
            }}
            className={styles['title-more']}
        >
            {
                i18n.t('查看更多')
            }
            <div className={styles['title-arrow']} />
        </div>
    </div>;

    private getCoverSrc = (metaData: Partial<MetaOfTemplate>) => metaData?.images?.pc_thumb_2x.url
        || metaData?.images?.pc_preview
        || metaData?.images?.mobile_thumb_2x;

    private getValidMeta = (metaOfEachType: string): Partial<MetaOfTemplate> => {
        try {
            const meta = metaOfEachType ? JSON.parse(metaOfEachType) : {};
            return meta;
        } catch (e) {
            window.log.error('getValidMeta err', e);
            return {};
        }
    };
}
